import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ECDetailHero from './components/ECDetailHero';
import ECDetailVideo from './components/ECDetailVideo';
import ECDetailContent from './components/ECDetailContent';

const ECDetailPage = () => {
  usePageMeta({
    title: 'ECサイトの詳細 | 株式会社MSK',
    ogTitle: 'ECサイトの詳細 | 株式会社MSK',
    description: '自信を持ってお勧めできるのは、作ったECサイトを自ら運営しているからこそ！株式会社MSKのECサイト制作サービスをご紹介します。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <ECDetailHero />
        <ECDetailVideo />
        <ECDetailContent />
      </main>
      <Footer />
    </div>
  );
};

export default ECDetailPage;